export const en = {
    'show-banners': 'Show'
};
